import {getWordPressProps, WordPressTemplate} from '@faustwp/core';

export default function Page(props) {
  return <WordPressTemplate {...props} />;
}

export async function getStaticProps(ctx) {
  const extra = {
    paged: 1
  };

  if (ctx?.params?.wordpressNode?.length > 6) {
    // Bail out for spam URLs
    return {
      notFound: true,
      revalidate: 10
    };
  } else if (ctx?.params?.wordpressNode?.length > 2) {
    // Get paged from the URL
    const lastTwoItems = ctx.params.wordpressNode.slice(-2);
    if (lastTwoItems[0] === 'page') {
      extra.paged = parseInt(lastTwoItems[1]) || 1;

      // Redirect to base if paged is 1, only when the URL has page/1
      if (extra.paged === 1) {
        return {
          redirect: {
            destination: `/${ctx.params.wordpressNode.slice(0, -2).join('/')}`,
            permanent: false,
          },
        };
      }
    }
  }

  // Get component props
  let wordPressProps;
  try {
    wordPressProps = await getWordPressProps({
      ctx,
      extra,
      revalidate: parseInt(process.env?.MOM_REVALIDATE_IN_SECS || 14400)
    });
  } catch (error) {
    // The WordPress origin can fail the data fetch (e.g. a 502 when a heavy
    // query OOMs PHP-FPM). Degrade gracefully instead of throwing a hard 500,
    // and retry soon via ISR rather than caching a broken page.
    console.error(
      `getWordPressProps failed for /${ctx?.params?.wordpressNode?.join('/') || ''}:`,
      error?.message || error
    );
    return {
      notFound: true,
      revalidate: 10
    };
  }

  // Not found for over-paginated pages
  const postsInfo = wordPressProps.props?.__TEMPLATE_QUERY_DATA__?.posts?.pageInfo?.offsetPagination;
  const videosInfo = wordPressProps.props?.__TEMPLATE_QUERY_DATA__?.videos?.pageInfo?.offsetPagination;
  const {total, hasPrevious} = postsInfo || videosInfo || {};
  if (
    typeof hasPrevious !== 'undefined' &&
    typeof total !== 'undefined' &&
    hasPrevious &&
    total === 0
  ) {
    return {
      notFound: true,
      revalidate: 10
    };
  }

  return wordPressProps;
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
